import { Search, X } from 'lucide-react';
import { DateRangeFilter } from './DateRangeFilter';

const Select = ({ label, value, onChange, options, testId }) => (
  <label className="flex flex-col gap-1 min-w-0">
    <span className="text-[10px] font-bold uppercase tracking-[0.16em] text-slate-500">{label}</span>
    <select value={value} onChange={(e) => onChange(e.target.value)} data-testid={testId}
      className="h-10 w-full rounded-lg border border-slate-200 bg-white px-3 text-sm font-medium text-slate-800 focus:border-[#14366C] focus:outline-none focus:ring-2 focus:ring-[#14366C]/15">
      {options.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
    </select>
  </label>
);

const opts = (allLabel, list) => [{ value: 'all', label: allLabel }, ...list.map((v) => (typeof v === 'string' ? { value: v, label: v } : v))];

export const VIEWS = [
  { key: 'all', label: 'All leads' },
  { key: 'new', label: 'New / unreviewed' },
  { key: 'followup', label: 'Follow-up due' },
  { key: 'flagged', label: 'Spam & test' },
];

export const LeadFilters = ({ filters, setFilters, options, counts }) => {
  const set = (k) => (v) => setFilters((f) => ({ ...f, [k]: v }));
  const o = options || { services: [], cities: [], channels: [], stages: [], owners: [], property_types: [] };
  const active = ['service', 'city', 'channel', 'stage', 'owner', 'review', 'property_type'].some((k) => filters[k] !== 'all') || filters.q;

  return (
    <div className="space-y-4" data-testid="lead-filters">
      <div className="flex flex-wrap items-center gap-2">
        <DateRangeFilter value={filters.date} onChange={set('date')} />
        <div className="relative flex-1 min-w-[200px] max-w-md">
          <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" />
          <input value={filters.q} onChange={(e) => set('q')(e.target.value)} placeholder="Search name, email, phone, city, message…"
            className="h-10 w-full rounded-full border border-slate-200 bg-white pl-9 pr-4 text-sm shadow-sm focus:border-[#14366C] focus:outline-none" data-testid="lead-search-input" />
        </div>
        {active && (
          <button onClick={() => setFilters((f) => ({ ...f, q: '', service: 'all', city: 'all', channel: 'all', stage: 'all', owner: 'all', review: 'all', property_type: 'all' }))}
            className="inline-flex h-10 items-center gap-1 rounded-full px-3 text-xs font-bold uppercase tracking-wider text-slate-500 hover:text-rose-600" data-testid="clear-filters-btn">
            <X className="h-3.5 w-3.5" />Clear
          </button>
        )}
      </div>
      <div className="grid grid-cols-2 gap-3 md:grid-cols-4 xl:grid-cols-7">
        <Select label="Service requested" value={filters.service} onChange={set('service')} options={opts('All services', o.services)} testId="filter-service" />
        <Select label="City (submitted)" value={filters.city} onChange={set('city')} options={opts('All cities', [...o.cities, { value: '__none__', label: 'No city given' }])} testId="filter-city" />
        <Select label="Source" value={filters.channel} onChange={set('channel')} options={opts('All sources', o.channels)} testId="filter-channel" />
        <Select label="Stage" value={filters.stage} onChange={set('stage')} options={opts('All stages', o.stages)} testId="filter-stage" />
        <Select label="Owner" value={filters.owner} onChange={set('owner')} options={opts('All owners', [{ value: 'unassigned', label: 'Unassigned' }, ...o.owners.map((u) => ({ value: u.id, label: u.name }))])} testId="filter-owner" />
        <Select label="Review status" value={filters.review} onChange={set('review')} options={opts('Any status', [{ value: 'new', label: 'New / unreviewed' }, { value: 'reviewed', label: 'Reviewed' }])} testId="filter-review" />
        <Select label="Property type" value={filters.property_type} onChange={set('property_type')} options={opts('All types', o.property_types)} testId="filter-property-type" />
      </div>
      <div className="flex flex-wrap gap-2" data-testid="lead-views">
        {VIEWS.map((v) => (
          <button key={v.key} onClick={() => set('view')(v.key)} data-testid={`lead-view-${v.key}`}
            className={`inline-flex items-center gap-2 rounded-full px-4 py-2 text-sm font-semibold transition-colors ${filters.view === v.key ? 'bg-[#14366C] text-white' : 'border border-slate-200 bg-white text-slate-700 hover:border-[#14366C]'}`}>
            {v.label}
            {counts?.[v.key] !== undefined && <span className={`rounded-full px-2 py-0.5 text-[11px] ${filters.view === v.key ? 'bg-white/20' : 'bg-slate-100'}`}>{counts[v.key]}</span>}
          </button>
        ))}
      </div>
    </div>
  );
};
